import { react, useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { useSnackbar } from 'notistack';
import LoadingIndicator from '../LoadingIndicator'
import TokenService from '../../services/TokenService';

export default function AddZipcode(props) {
    const handleClose = () => {
        props.Close('');
        //setisShown(false);
    };
    const [state, setState] = useState('Input');
    const [zipCode, setZipcode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [formValidation, setFormValidation] = useState({
        isValid: false,
        errors: []
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    function checkKeyPress(e) {
        const { key, keyCode } = e;
      //  console.log(key, keyCode);
        if (keyCode === 13) {
            validateAndSend();
        }
    }
    

    function validate() {

        let isValid = true;
        let errors = [];

        if (zipCode.trim() == '') {
            errors["ZipCode"] = "Enter a Zip Code to add it.";
            isValid = false;
        }
        else {
            if (zipCode.trim().length !== 5) {
                errors["ZipCode"] = "Enter a 5 digit Zip Code";
                isValid = false;
            }
            else if (isNaN(zipCode)) {
                errors["ZipCode"] = "Zip Code must be numeric";
                isValid = false;
            }
        }

        if (isValid) {
            if (props.ExistingZipcodes !== null && props.ExistingZipcodes !== undefined) {
                for (let i = 0; i < props.ExistingZipcodes.length; i++) {
                    if (props.ExistingZipcodes[i].AreaType == 1 &&
                        props.ExistingZipcodes[i].Zipcode == zipCode) {
                        errors["ZipCode"] = "You already have this Zip";
                        isValid = false;
                        break;
                    }
                }
            }
        }

        setFormValidation({
            isValid: isValid,
            errors: errors
        });

        return {
            isValid: isValid,
            errors: errors
        }
    }

    function validateAndSend() {

        if (validate().isValid) {
            setIsLoading(true);
            let postData = {
                serviceArea: {
                    ServiceAreaId: 0,
                    ReturnerId: 0,
                    AreaType: 1,
                    Zipcode: zipCode,
                    RadiusMiles: 0,
                    Latitude: 0,
                    Longitude: 0,
                    Latitude2: 0,
                    Longitude2: 0
                }
            }
            TokenService.post(postData, 'AddServiceArea')
                .then((response) => {
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        props.Close(response);

                        let jsonData = JSON.parse(response.JsonData);
                        let level = JSON.parse(jsonData.ReturnerLevel);
                        let event = new CustomEvent('ReturnerLevel_Updated', {
                            detail: level
                        });
                        document.getElementsByTagName('body')[0].dispatchEvent(event);
                    }
                    else {
                        setIsLoading(false);
                        let errors = [];
                        errors["ZipCode"] =response.Message;
                        setFormValidation({
                            isValid: false,
                            errors: errors
                        });
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });
        }
    }

   
    return (<div>
        <Dialog
            open={true}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Add a new Zip Code to your service area
            </DialogTitle>
            <DialogContent>
                {isLoading ?
                    <LoadingIndicator />
                    :
                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                        <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                            <TextField style={{ width: '200px', alignSelf: 'flex-start' }} label="Zip Code" onChange={(e) => setZipcode(e.target.value)} onKeyDown={checkKeyPress} value={zipCode} variant="outlined" inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['ZipCode'] !== undefined ? formValidation.errors['ZipCode'] : ''}</div>
                        </div>
                    </div>
                }

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    Cancel
                </Button>
                <Button onClick={validateAndSend} variant="contained" color="sipzeeGreen" autoFocus>
                    Add Zip
                </Button>
            </DialogActions>
        </Dialog>
    </div>
    );

    

    

    


}